// extracted by mini-css-extract-plugin
module.exports = {"images":"PropertyImages_images_4pzRn","image":"PropertyImages_image_2eIsK","setImageButton":"PropertyImages_setImageButton_1xzwJ"};